(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/shared/process-campaign-response.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/shared/process-campaign-response.js');

'use strict';

let productMapping;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  productMapping = trinidad.components.require('numbergames', 'product-mapping').productMapping;
} else {
  productMapping = svs.numbergames.productMapping;
}
function mapCampaign(campaign) {
  const {
    name,
    startDate,
    drawNumber,
    drawStateId,
    drawTypeId,
    endDate,
    drawDate,
    smallImageUrl,
    largeImageUrl,
    products,
    participationTermsId,
    winDivs,
    url,
    chances
  } = campaign;
  return {
    name,
    startDate,
    drawNumber,
    drawStateId,
    drawTypeId,
    endDate,
    drawDate,
    smallImageUrl,
    largeImageUrl,
    products,
    participationTermsId,
    winDivs,
    url,
    chances
  };
}
function processCampaignResponse() {
  let {
    campaigns
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (Array.isArray(campaigns)) {
    const result = {};
    const AcCampaigns = [];
    campaigns.forEach(campaign => {
      const productId = productMapping.getProductId(campaign.products[0].productId);
      if (campaign.drawTypeId === 1) {
        AcCampaigns.push(mapCampaign(campaign));
        result[productId] = [...AcCampaigns];
      } else if (campaign.drawTypeId === 3) {
        if (!result[productId]) {
          result[productId] = [mapCampaign(campaign)];
        }
      }
    });
    return result;
  }
  return null;
}
if (typeof exports === 'object') {
  module.exports = {
    processCampaignResponse,
    mapCampaign
  };
} else {
  svs.numbergames.campaign.shared.processCampaignResponse = processCampaignResponse;
}

 })(window);